// clase retorna los rearch params de la url

import queryString from 'query-string';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { fromB64 } from 'src/utils/functiones';

const useQueryString = () => {
  const location = useLocation();
  return useMemo(() => {
    const qParams = queryString.parse(location.search);
    if (qParams?.query) {
      const query = fromB64(qParams?.query);
      return {
        ...qParams,
        ...query,
      };
    }
    return qParams;
  }, [location.search]);
};

export default useQueryString;
